import React, { useEffect, useState } from "react";
import {
  getProfileAction,
  logoutAction,
  getAllCategoriesAction,
  getAllCourseLevelAction,
  getAllAudioLanguageAction,
} from "@redux/actions";
import { guards } from "@routing/guards";
import { publics } from "@routing/publics";
// import { routes } from "@routing/routes";
import { Spinner, Stack, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ScrollToTop } from "@routing/ScrollToTop";
import { BrowserRouter, Routes } from "react-router-dom";
import { ReactComponent as Logo } from "@assets/main_logo.svg";
import { ReactComponent as FallbackLogo } from "@assets/svgs/logo1.svg";
import styles from "./App.module.css";

function App() {
  // state
  const [content, setContent] = useState(null);
  const [contentLoading, setContentLoading] = useState(true);

  // variables
  let spinner = null;

  // logics before hooks

  // hooks
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.auth);
  const { profile } = useSelector((state) => state.user);
  const { getAllCourseLevel } = useSelector((state) => state.courseLevel);
  const { allCategories } = useSelector((state) => state.category);
  const { getAllAudioLanguage } = useSelector((state) => state.audioLanguage);
  const { isAuth } = login;

  // logics
  const handleSignOut = () => dispatch(logoutAction());

  const handleRetry = () => {
    setContentLoading(true);
    dispatch(getProfileAction());
  };

  const showContent = () => {
    setContentLoading(false);
    setContent(
      <ScrollToTop>
        <Routes>
          {/* {routes} */}
          {publics}
          {guards}
        </Routes>
      </ScrollToTop>
    );
  };

  const showFallback = () => {
    setContentLoading(false);
    setContent(
      <div className={styles.appFallback}>
        <Stack className={styles.appFallbackContent} gap={4}>
          <FallbackLogo width={150} />
          <h1 className="text-white">Server is under Maintenance</h1>
          <p className="text-white">
            Our server is under maintenance, we apologize for the inconvenience.
            Please comeback later.
          </p>
          <div className={styles.fallbackFunctions}>
            <Button onClick={handleSignOut}>Sign Out</Button>
            <Button variant="outline-primary" onClick={handleRetry}>
              Try Again
            </Button>
          </div>
        </Stack>
      </div>
    );
  };

  // UI partials
  if (contentLoading)
    spinner = (
      <div className={styles.spinner}>
        <Stack className="m-auto" direction="horizontal" gap={2}>
          <Spinner animation="grow" size="sm" variant="danger" />
          <Spinner animation="grow" variant="danger">
            <Logo />
          </Spinner>
          <Spinner animation="grow" size="sm" variant="danger" />
        </Stack>
      </div>
    );

  // effects
  useEffect(() => {
    !getAllAudioLanguage.data && dispatch(getAllAudioLanguageAction());
    !getAllCourseLevel.data && dispatch(getAllCourseLevelAction());
    !allCategories.data && dispatch(getAllCategoriesAction());
    if (isAuth) {
      setContentLoading(true);
      dispatch(getProfileAction());
    } else showContent();
  }, [dispatch, isAuth]);

  useEffect(() => {
    const processing =
      profile.processing &&
      allCategories.processing &&
      getAllAudioLanguage.processing &&
      getAllCourseLevel.processing;
    const success =
      profile.success &&
      allCategories.success &&
      getAllAudioLanguage.success &&
      getAllCourseLevel.success;
    if (success !== null) {
      if (!processing) success ? showContent() : showFallback();
    }
  }, [
    profile.processing,
    allCategories.processing,
    getAllAudioLanguage.processing,
    getAllCourseLevel.processing,
  ]);

  // render
  return (
    <BrowserRouter>
      <div className={styles.App}>
        {content}
        {spinner}
      </div>
    </BrowserRouter>
  );
}

export { App };
